import { Badge } from '@/components/ui/badge';
import type { BackendRunEvent } from '@/lib/reqqyBackend';

interface Props {
  events: BackendRunEvent[];
}

export function RunEventTimeline({ events }: Props) {
  if (events.length === 0) {
    return <p className="text-sm text-muted-foreground">No events yet.</p>;
  }

  return (
    <div className="space-y-2">
      {events.map((ev, i) => (
        <div key={ev.id ?? i} className="flex items-start gap-3">
          {/* Timeline dot + line */}
          <div className="flex flex-col items-center pt-1.5">
            <div className="w-2 h-2 rounded-full bg-primary shrink-0" />
            {i < events.length - 1 && <div className="w-px flex-1 bg-border mt-1" />}
          </div>

          <div className="pb-3 min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <Badge variant="outline" className="text-xs font-mono">
                {ev.event_type}
              </Badge>
              {ev.created_at && (
                <span className="text-xs text-muted-foreground">
                  {new Date(ev.created_at).toLocaleTimeString()}
                </span>
              )}
            </div>
            <p className="text-sm mt-0.5">{ev.message}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
